import { HiringDashboardDataState, HiringDashboardState } from './types';

export const INITIAL_DASHBOARD_DATA_STATE: HiringDashboardDataState = {
  metrics: null,
  v1Data: null,
  v2Data: null,
  companyBusinessProfile: null,
};

export const INITIAL_DASHBOARD_STATE: HiringDashboardState = {
  ...INITIAL_DASHBOARD_DATA_STATE,
  metricsLoading: false,
  metricsError: null,
  metricsSuccess: null,

  v1DataLoading: false,
  v1DataError: null,
  v1DataSuccess: null,

  v2DataLoading: false,
  v2DataError: null,
  v2DataSuccess: null,

  companyBusinessProfileLoading: false,
  companyBusinessProfileError: null,
  companyBusinessProfileSuccess: null,
};
